// ----------------------------------------------------------------------------
// Template: 404
// ----------------------------------------------------------------------------
// 404 File Not Found Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/hero/hero';
import 'sections/main-404/main-404';